import { render, staticRenderFns } from "./AdminAppShowEdit.vue?vue&type=template&id=76c7c4f7&scoped=true"
import script from "./AdminAppShowEdit.vue?vue&type=script&lang=js"
export * from "./AdminAppShowEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminAppShowEdit.vue?vue&type=style&index=0&id=76c7c4f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c7c4f7",
  null
  
)

export default component.exports